
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/overview",
      function () {
        return require("private-next-pages/events/overview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/overview"])
      });
    }
  